import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import * as DateHelper from '@/Utility/DateHelper';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

declare let moment: moment.MomentStatic;

export default class HistorizationBannerViewModel extends ControlViewModel {
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * Der Wert
     */
    public value: KnockoutObservable<string>;

    /**
     * Das ViewModel für das Label
     */
    public label: LabelViewModel;

    /**
     * Das ViewModel für die HistorizationBanner
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.value = this.observableOrDefault(params.value, '');
        this.label = this.paramOrDefault(() => {
            let text = this.value();
            let ergName = null;
            let replacements: any = {};
            let caption = null;

            if (text == null || text === '') {
                ergName = 'IS_HISTORIZED';
            } else {
                let date = moment(text, ['DD.MM.YYYY']);

                if (date.isValid()) {
                    replacements.DATE = new this.LabelViewModel({
                        caption: DateHelper.toString(date.toDate(), false)
                    });

                    ergName = 'IS_HISTORIZED_DATE';
                } else {
                    caption = text;
                }
            }

            return new this.LabelViewModel({
                parentLocator: this.locator,
                locator: 'label',
                ergName: ergName,
                caption: caption,
                replacements: replacements
            });
        })();
    }
}

ComponentManager.setViewModel('HistorizationBannerViewModel', HistorizationBannerViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');